import { ImageProps } from 'next/image';

import { PropsWithClassName } from '~types/Props.types';

export enum NextImageMods {
  FitContain = 'fitContain',
}

export type NextImageProps = PropsWithClassName<
  Omit<ImageProps, 'width' | 'height'> & {
    src: string;
    classNameInner?: string;
    mods?: NextImageMods[];
    strapiSource?: string;
  }
>;
